import script from "./ShakyoRightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoRightBar.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoRightBar.vue?vue&type=style&index=0&id=33a4830a&scoped=true&lang=css"
import "./ShakyoRightBar.vue?vue&type=style&index=1&id=33a4830a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a4830a"]])

export default __exports__